import { useEffect, useRef, useState } from "react";
import {
	ResponsiveContainer,
	BarChart,
	XAxis,
	YAxis,
	Legend,
	Bar,
	LabelList,
	Tooltip,
	Cell,
} from "recharts";
import { numberFormatter } from "../../../utils";
import { maxWidth, minWidth, width } from "@mui/system";

const L2Profile = (props: any) => {
	const selected = props.selection.L2;
	const COLORS: any = {
		"DATA COMMUNICATION": "#3B60A0",
		ELECTRICAL: "#86BC25",
		MRO: "#334422",
		LIGHTING: "#0097A9",
		"Not Selected": "#5EC1C8",
	};
	const customTooltip = ({ active, payload }: any) => {
		if (active && payload && payload.length) {
			const data = payload[0].payload;

			const popupStyle = {
				width: "fit-content",
				background: "white",
				border: "1px solid #ccc",
				boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
				borderRadius: "1vh",
				cursor: "pointer",
				color: "black",
			};

			return (
				<div style={popupStyle}>
					{/* Header Row */}
					<div className="w-full flex justify-start h-[3vh] items-center bg-[#f0f4f8] py-[3vh] px-[1vh] textSmall">
						<div className="font-bold uppercase">L2 : </div>
						<div
							className="font-bold ml-1"
							style={{ color: "#3f3f3f" }}
						>
							{data.category}
						</div>
					</div>
					{/* Data Row */}
					<div className="h-fit p-[1vh] mt-[.5vh] mb-[.5vh]">
						<p
							className="label"
							style={{ padding: "0", margin: "0" }}
						>
							<label
								className="graph-label-small"
								style={{
									color: "#5a5a5a",
									fontWeight: "normal",
								}}
							>
								Spend ($):{" "}
							</label>
							<label
								className="graph-label-small"
								style={{
									color: "#3f3f3f",
									fontWeight: "bold",
								}}
							>
								{numberFormatter(data.cost, 0)}
							</label>
						</p>
					</div>
				</div>
			);
		}
		return null;
	};

	const handleL2Selection = (data: any) => {
		props.handleClick(data.category);
	};

	const updateFill = (d: any) => {
		if (selected == null) {
			return COLORS[d.l1];
		} else {
			if (selected.includes(d.category)) {
				return /* "#046a38" */ COLORS[d.l1];
			} else {
				return "#53565a";
			}
		}
	};

	return (
		<div className="h-full w-full flex flex-col">
			<div className="headSpace">
				<div className="headContent">L2 Spend Profile</div>
			</div>
			<div className="grow w-full h-[90%]">
				<ResponsiveContainer width="100%" height="100%">
					<BarChart
						data={props.data}
						margin={{top:15}}
					>
						<XAxis
							axisLine={false}
							hide={props.data.length > 5}
							tickLine={false}
							dataKey={(d: any) => {
								if (props.data.length > 5) {
									return "";
								} else {
									if (d.category.length > 10) {
										return (
											d.category.substring(0, 10) + "..."
										);
									} else {
										return d.category;
									}
								}
							}}
							stroke="white"
							fontSize="1.4vh"
						></XAxis>
						<YAxis
							stroke="white"
							hide
							fontSize="1.5vh"
							tickFormatter={(value: number) =>
								numberFormatter(value, 0, "$")
							}
						/>
						<Tooltip
							contentStyle={{
								color: "white",
								backgroundColor: "rgb(26, 25, 22)",
							}}
							cursor={{ strokeDasharray: "3 3", fill: "#f1f1f1" }}
							content={customTooltip}
						/>
						<Bar dataKey="cost" barSize={40}>
							{props.data &&
								props.data.map((d: any, index: number) => {
									return (
										<Cell
											key={d.category}
											fill={updateFill(d)}
											onClick={() => handleL2Selection(d)}
										></Cell>
									);
								})}
							<LabelList
								dataKey="cost"
								fill="black"
								fontWeight={700}
								fontSize="0.6vw"
								formatter={(value: number) =>
									value == 0
										? null
										: numberFormatter(value, 0, "$")
								}
								position="top"
							></LabelList>
						</Bar>
					</BarChart>
				</ResponsiveContainer>
			</div>
		</div>
	);
};

export default L2Profile;
